import {Stack} from "@mui/material";
import {Navigate, useParams} from "react-router";
import {appSession} from "../../../TR3AD.ts";
import WidgetHeader from "../../../widgets/WidgetHeader.tsx";
import {appStyles} from "../../../AppStyles.ts";

function UXTagSelect() {
    const { networkUID } = useParams();

    return (
        <Stack direction="column" width="100%" minHeight="100vh">
            {appSession.activeSession() === false ? (
                <Navigate to="/" />
            ) : (
                <Stack direction="column" spacing={1} width="99%" >
                    <WidgetHeader
                        title="Tags"
                        breadcrumbs={[
                            {
                                display: "Networks",
                                linkTo: `/networks/`,
                                activeView: false
                            },
                            {
                                display: String(networkUID),
                                linkTo: `/networks/${networkUID}`,
                                activeView: false
                            },
                            {
                                display: "Tags",
                                linkTo: "",
                                activeView: true
                            }]}
                    />
                    <Stack
                        sx={appStyles.sectionBox}
                        spacing={2}
                        width="100%"
                        height="100%"
                        alignItems="start"
                    >

                    </Stack>
                </Stack>
            )}
        </Stack>
    );
}

export default UXTagSelect;
